import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21 9.74351c0 1.00609-.3941 1.95439-1.1103 2.66969l-3.2343 3.2333H21v1.8948h-7.5789v-1.3396l5.1319-5.1309c.3552-.3553.5523-.828.5523-1.32729 0-.50021-.1971-.97295-.5552-1.33105-.7162-.71431-1.962-.71431-2.6782 0l-1.2552 1.25526-1.3396-1.33957 1.2543-1.25526c1.4305-1.43052 3.9278-1.43052 5.3583 0C20.6059 7.7891 21 8.73741 21 9.74351zM9.63154 10.9098V6.17299h1.89476V17.5414H9.63154v-4.7369H4.89473v4.7369H3V6.17299h1.89473v4.73681h4.73681z",
    fill: "currentColor"
  }));
});